var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeStudent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6028 10.4241C18.4867 5.96652 15.2881 3.72322 11.0001 3.72322C6.70995 3.72322 3.51352 5.96652 1.39745 10.4263C1.31257 10.6061 1.26855 10.8024 1.26855 11.0011C1.26855 11.1999 1.31257 11.3962 1.39745 11.5759C3.51352 16.0335 6.71218 18.2768 11.0001 18.2768C15.2903 18.2768 18.4867 16.0335 20.6028 11.5737C20.7747 11.2121 20.7747 10.7924 20.6028 10.4241ZM11.0001 16.6697C7.39968 16.6697 4.76352 14.8438 2.90415 11C4.76352 7.15626 7.39968 5.33036 11.0001 5.33036C14.6006 5.33036 17.2367 7.15626 19.0961 11C17.239 14.8438 14.6028 16.6697 11.0001 16.6697ZM10.9108 7.07144C8.7412 7.07144 6.98227 8.83036 6.98227 11C6.98227 13.1696 8.7412 14.9286 10.9108 14.9286C13.0805 14.9286 14.8394 13.1696 14.8394 11C14.8394 8.83036 13.0805 7.07144 10.9108 7.07144ZM10.9108 13.5C9.52915 13.5 8.41084 12.3817 8.41084 11C8.41084 9.61831 9.52915 8.50001 10.9108 8.50001C12.2925 8.50001 13.4108 9.61831 13.4108 11C13.4108 12.3817 12.2925 13.5 10.9108 13.5Z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeStudent);
export default __webpack_public_path__ + "static/media/eye_student.28dc21e1e4398205c3b3204beb1c80f7.svg";
export { ForwardRef as ReactComponent };